import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Pagination from "../../common/TablePagination";
import "./WithdrawmoneyTransactions.scss";
import { separateDateTimeAndConvertToLocale } from "../../../utils/utilFunctions";

const formatUnixDate = (unixTimestamp) => {
  if (!unixTimestamp) return "-";
  return (
    separateDateTimeAndConvertToLocale(new Date(Number(unixTimestamp) * 1000))
      ?.localDate || "-"
  );
};

const WithdrawalsDataTable = ({
  credit = [],
  currentPage = 1,
  totalPages = 1,
  handlePageChange = () => {},
}) => {

  const columns = [
    {
      name: "ID",
    },
    {
      name: "Date",
    },
    {
      name: "Account Name",
    },
    {
      name: "Subscription Amount",
    },
    {
      name: "Funds",
    },
  ];

  return (
    <div className="col-span-12">
      {/* Card list on mobile */}
      <div className="sm:hidden space-y-3 mt-2">
        {Array.isArray(credit) && credit.length > 0 ? (
          credit.map((item, idx) => (
            <div key={idx} className="bg-white rounded-[10px] border border-[#EAEAEA] p-4 shadow-sm">
              <div className="flex justify-between text-[11px] text-[#8C8C8C]">
                <span>ID</span>
                <span className="text-[#303030] font-medium truncate max-w-[65%]">{item?._id}</span>
              </div>
              <div className="h-px bg-[#F1F1F1] my-2" />
              <div className="flex justify-between text-[11px] text-[#8C8C8C]">
                <span>Date</span>
                <span className="text-[#303030] font-medium">{formatUnixDate(item?.transactionDate)}</span>
              </div>
              <div className="h-px bg-[#F1F1F1] my-2" />
              <div className="flex justify-between text-[11px] text-[#8C8C8C]">
                <span>Account Name</span>
                <span className="text-[#303030] font-medium truncate max-w-[65%] text-right">{item?.accountName}</span>
              </div>
              <div className="h-px bg-[#F1F1F1] my-2" />
              <div className="flex justify-between text-[11px] text-[#8C8C8C]">
                <span>Subscription Amount</span>
                <span className="text-[#303030] font-semibold">${(item?.totalFunds / 100).toFixed(2)}</span>
              </div>
              <div className="flex justify-between mt-1 text-[11px] text-[#8C8C8C]">
                <span>Funds</span>
                <span className="text-[#303030] font-semibold">${(item?.fundraiserFunds / 100).toFixed(2)}</span>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-8 px-4">
            <p className="text-[14px] font-poppins font-[500] text-[#303030] mb-2">
              No Transactions Yet
            </p>
            <p className="text-[12px] font-poppins font-[400] text-[#767676]">
              Start earning by creating your marketing page to share with supporters.
            </p>
          </div>
        )}
      </div>

      {/* Table on tablet/desktop */}
      <TableContainer className="hidden sm:block w-[100%] overflow-x-auto">
        <Table
          sx={{ borderCollapse: "separate", borderSpacing: "0px 8px", minWidth: 640 }}
          aria-label="simple table"
        >
          <TableHead className="bg-[#00ADEF] ">
            <TableRow className="h-[50px]" sx={{ boxShadow: "0px 4px 4px 0px #00000040" }}>
              {columns.map((column) => (
                <TableCell key={column.name} className="!text-[#FFFFFF]">{column.name}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {credit && credit?.length > 0 ? (
              credit?.map((withdrawal, index) => (
                <TableRow
                  key={index}
                  className="h-[50px]"
                  sx={{
                    boxShadow: "0px 4px 4px 0px #00000040",
                    backgroundColor: (index + 1) % 2 !== 0 ? "#F5F5F5" : "#FFFFFF",
                  }}
                >
                  <TableCell>{withdrawal?._id}</TableCell>
                  <TableCell>{formatUnixDate(withdrawal?.transactionDate)}</TableCell>
                  <TableCell className="max-w-[80px] truncate">{withdrawal?.accountName}</TableCell>
                  <TableCell>${(withdrawal?.totalFunds / 100).toFixed(2)}</TableCell>
                  <TableCell>${(withdrawal?.fundraiserFunds / 100).toFixed(2)}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={columns.length} align="center" className="!py-8">
                  <div className="flex flex-col items-center justify-center">
                    <p className="text-[16px] font-poppins font-[500] text-[#303030] mb-2">
                      No Transactions Yet
                    </p>
                    <p className="text-[14px] font-poppins font-[400] text-[#767676] max-w-md">
                      Start earning by creating your marketing page to share with supporters.
                    </p>
                  </div>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Pagination
        totalPages={totalPages}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
      />
    </div>
  );
};

export default WithdrawalsDataTable;
